import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useConfig } from '../contexts/ConfigContext';

export default function Settings() {
  const { user } = useAuth();
  const { config } = useConfig();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-testid="settings-page">
      <div className="lg:col-span-2 space-y-5">
        <Card title="Profile">
          <KV label="Email" value={user?.email || '-'} mono />
          <KV label="User ID" value={user?.id || '-'} mono />
        </Card>

        <Card title="Workspace defaults">
          <KV label="Default origin" value="India" />
          <KV label="Default mode" value="Sea Freight" />
          <KV label="Reporting timezone" value="Asia/Kolkata" />
          <p className="text-xs text-slate-500 mt-3">These defaults are pre-filled when creating new shipments.</p>
        </Card>

        <Card title="Notifications">
          <Toggle label="Email me when validation completes" defaultOn />
          <Toggle label="Weekly summary of open issues" defaultOn />
          <Toggle label="Notify reviewers of blocking risks" />
        </Card>
      </div>

      <div className="space-y-5">
        <Card title="Application">
          <KV label="App" value={config?.app_name} />
          <KV label="Login" value={config?.enable_login === false ? 'Disabled' : 'Enabled'} />
          <KV label="Public auth" value={config?.enable_public_auth ? 'Enabled' : 'Disabled'} />
          <KV label="Supabase URL" value={config?.supabase_url || '-'} mono />
        </Card>

        <Card title="Compliance principle">
          <p className="text-sm text-slate-300 leading-relaxed">
            ComplyTradeIQ provides advisory pre-shipment review. AI interprets, rules decide, humans act.
            Validation outputs are never substitutes for customs decisions.
          </p>
        </Card>
      </div>
    </div>
  );
}

function Card({ title, children }) {
  return (
    <div className="rounded-xl border border-white/10 bg-navy-900 p-6">
      <div className="text-xs uppercase tracking-widest text-slate-500 font-mono mb-4">{title}</div>
      <div className="space-y-3">{children}</div>
    </div>
  );
}

function KV({ label, value, mono }) {
  return (
    <div className="flex items-center justify-between gap-4">
      <span className="text-sm text-slate-400">{label}</span>
      <span className={`text-sm text-white truncate ${mono ? 'font-mono text-xs' : ''}`}>{value || '-'}</span>
    </div>
  );
}

function Toggle({ label, defaultOn }) {
  const [on, setOn] = React.useState(!!defaultOn);
  return (
    <div className="flex items-center justify-between" data-testid={`toggle-${label.toLowerCase().replace(/\s+/g, '-').slice(0, 30)}`}>
      <span className="text-sm text-slate-300">{label}</span>
      <button
        onClick={() => setOn(!on)}
        className={`relative h-6 w-11 rounded-full transition-colors ${on ? 'bg-cyan-glow' : 'bg-navy-800 border border-white/10'}`}
      >
        <span className={`absolute top-0.5 ${on ? 'right-0.5' : 'left-0.5'} h-5 w-5 rounded-full bg-white transition-all`} />
      </button>
    </div>
  );
}
